// extracted by mini-css-extract-plugin
module.exports = {"surveysDraftContainer":"surveysDraftView_surveysDraftContainer__3G3FI","search":"surveysDraftView_search__3vOrt"};